import React from 'react';

/**
 * Clickable dashboard module card. Uses theme CSS variables for light/dark mode.
 */
const NavCard = ({ title, description, onClick, icon: Icon, 'aria-label': ariaLabel }) => {
  return (
    <button
      type="button"
      className="nav-card"
      onClick={onClick}
      aria-label={ariaLabel || title}
    >
      {Icon && (
        <span className="nav-card__icon" aria-hidden="true">
          <Icon className="nav-card__icon-svg" />
        </span>
      )}
      <span className="nav-card__body">
        <span className="nav-card__title">{title}</span>
        <span className="nav-card__description">{description}</span>
      </span>
      <span className="nav-card__arrow" aria-hidden="true">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M5 12h14M13 6l6 6-6 6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
    </button>
  );
};

export default NavCard;
